import { IFormConfigurationContext } from '@wyz/types';
import { createContext } from 'react';
import {
  ISupplierTypeOptionItem,
  ITyreCountOptionItem,
  IVehicleTypeGroupsOptionItem,
} from '~/common/types';
import { IActiveVehicleTypeGroupReturnType } from '~/purchase/hooks';

export type IFormContext = {
  mode: IFormConfigurationContext['mode'];
  vehicleTypeGroups: IActiveVehicleTypeGroupReturnType & {
    optionItems: Array<IVehicleTypeGroupsOptionItem>;
  };
  tyreCounts: { optionItems: Array<ITyreCountOptionItem> };
  supplierTypes: { optionItems: Array<ISupplierTypeOptionItem> };
};
export const FormContext = createContext<IFormContext | undefined>(undefined);
